export class AuthConstants {
  public static USER_TOKEN_OLD_WEBSITE_KEY = 'userTokenOldWebsite';

  public static ACCOUNT_DISABLED_ERROR = 'Account disabled';
  public static CARRIER_ADMIN_KEYCLOAK_KEY = 'carrier-admin';
  public static CARRIER_USER_KEYCLOAK_KEY = 'carrier-user';
  public static PORTAL_ADMIN_KEYCLOAK_KEY = 'portal-admin';
  public static BUSINESS_ADMIN_KEYCLOAK_KEY = 'business-admin';
}
